import { booleanAttribute, Component, input, output } from '@angular/core';
@Component({
  selector: 'lepi-color-picker-item',
  templateUrl: './color-picker-item.component.html',
})
export class ColorPickerItemComponent {
  setColor = output<string>();
  remove = output<void>();
  color = input<string>('');
  removeMode = input<boolean, string>(false, { transform: booleanAttribute });

  handleRemove(ev: any) {
    ev.stopPropagation();
    ev.preventDefault();

    this.remove.emit();
  }
}
